<script>
    import { Line } from 'vue-chartjs'

    export default {
        extends: Line,
        props: ['chartdata', 'options','unit','dataname','linecolor','pointcolor'],
        mounted () {
            Chart.defaults.global.legend.display = false;
            this.renderChart({
                labels: this.chartdata,
                datasets: [
                    {
                        label: this.dataname,
                        backgroundColor: 'transparent',
                        pointBackgroundColor: this.pointcolor == null ? '#FF5100':this.pointcolor,
                        borderColor: this.linecolor == null ? '#507CD6':this.linecolor,
                        data: this.options,
                    }
                ]
            },
            {
                responsive: true, maintainAspectRatio: false,
                // onClick: function () {
                //     this.$router.push('/');
                // }
            })
        }
    }
</script>

<style scoped>

    * {
        font-size: 13px;
    }

</style>
